import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion'; // Import motion from framer-motion

interface ErrorMessageProps {
  messages: string[];
  clearErrors: () => void;
  duration?: number;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  messages,
  clearErrors,
  duration = 2000,
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (currentMessageIndex >= messages.length) {
      clearErrors();
      return;
    }

    const timer = setTimeout(
      () => setCurrentMessageIndex((prevIndex) => prevIndex + 1),
      duration
    );

    return () => clearTimeout(timer);
  }, [currentMessageIndex, messages, duration, clearErrors]);

  if (currentMessageIndex >= messages.length) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 space-y-2">
      {messages.map(
        (message, index) =>
          index === currentMessageIndex && (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.3 }}
              className={twMerge(
                'bg-red-500 text-white px-4 py-2 rounded-md shadow-lg flex items-center gap-2'
              )}
            >
              <span className="text-sm">{message}</span>
            </motion.div>
          )
      )}
    </div>
  );
};

export default ErrorMessage;
